import axios from 'axios'
import store from '../store'
import { Message } from 'element-ui'
// 创建axios实例
const request = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 10000
})

// request拦截器
request.interceptors.request.use(
  config => {
    const url = config.url
    // console.log(config)
    if (config.params) {
      if (url.indexOf('obs/') !== -1) {
        if (url.indexOf('getToken') !== -1) {
          config.params.appid = process.env.RES_APPID
          config.params.appkey = process.env.RES_APPKEY
        } else if (store.getters.restoken !== '') {
          config.params.token = store.getters.restoken
        }
      } else if (url.indexOf('getToken') !== -1) {
        config.params.appid = process.env.APPID
        config.params.appkey = process.env.APPKEY
      } else {
        if (store.getters.token !== '') {
          config.params.token = store.getters.token
          config.params.appid = process.env.APPID
        }
      }
    }

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
request.interceptors.response.use(
  response => {
    // const url = response.config.url
    // if (response.data === 'auth fail') {
    //   Message({
    //     message: '系统配置异常。',
    //     type: 'error',
    //     duration: 2 * 1000
    //   })
    //   return Promise.reject('TOKEN失败')
    // }
    // if (response.data.result === '100006') {
    //   store.dispatch('resetUserToken')
    //   Vue.prototype.$confirm('您的登录信息已经失效，现在重新登录么？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     window.location.href = 'login.html?re=' + encodeURIComponent(window.location.href)
    //   })
    //   return Promise.reject('Session失败')
    // }
    // if (response.data.result === '100003') {
    //   // 此时判断如果是apitoken则自动重新计算token，重新发送请求， 如果是资源token，重新登录
    //   if (url.indexOf('obs/') !== -1) {
    //     store.dispatch('resetUserToken')
    //     Vue.prototype.$confirm('您的登录信息已经失效，现在重新登录么？', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       window.location.href = 'login.html?re=' + encodeURIComponent(window.location.href)
    //     })
    //     return Promise.reject('TOKEN失败')
    //   } else {
    //     // 重新加载api token
    //     return new Promise((resolve, reject) => {
    //       store.dispatch('getApiToken').then(() => {
    //         console.log('加载apitoken后重试原请求')
    //         response.config.params.token = store.getters.token
    //         axios.request(response.config).then((resres) => {
    //           resolve(resres.data)
    //         }).catch(() => {
    //           reject()
    //           Message({
    //             message: '系统异常',
    //             type: 'error',
    //             duration: 5 * 1000
    //           })
    //         })
    //       }).catch(() => {
    //         Message({
    //           message: '系统异常',
    //           type: 'error',
    //           duration: 5 * 1000
    //         })
    //       })
    //     })
    //   }
    // }
    // if (response.data.result === '100004') {
    //   Message({
    //     message: '参数有误',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject('参数有误')
    // }
    // if (response.data.result === '999999') {
    //   Message({
    //     message: '失败',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject('失败')
    // }
    return response.data
  },
  error => {
    console.log(error)
    Message({
      message: '发生异常，请稍后重试。',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject('发生异常，请稍后重试。')
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/request.js